(() => {
  const fileUrl = pdfUrl;
  if (!fileUrl) return;

  if (PDFObject.supportsPDFs) {
    PDFObject.embed(fileUrl, "#my-pdf");
  } else {
    window.location.href = fileUrl;
  }
})();
